import { MainUseCase, RequestDriver, SecurityManager, UseCaseMessageType } from "@curio/client";
import { Session } from "./Session";
import { isAuthError } from "./isAuthError";
import { ABORT } from "@curio/client/utils/constants";

export interface ConfigService {
  url: string;
  server: string;
  system: number;
  port: number;
  module: number;
  version: number;
}

export interface Service {
  service?: string;
  port: string;
  server: string;
  system: string;
  isapi?: string;
}

export const STORAGEKEY = "br.com.ged";

export class SessionManager extends SecurityManager {
  public session: MainUseCase | undefined;
  private _service: ConfigService;
  private _driver: RequestDriver;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- @curio não tipa o service
  constructor(service: any, driver: RequestDriver) {
    super(service, driver);
    this._service = service;
    this._driver = driver;
  }

  public async openMainUseCase<U extends typeof MainUseCase>(username: string, password: string, constructor?: U) {
    this.session = await super.openMainUseCase(username, password, constructor);
    this.session!.addListener(ABORT, () => this._unauthenticate(false));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- @curio não tipa a mensagem
    this.session!.addListener(UseCaseMessageType.RESPONSE, (message: any) => {
      if (isAuthError(message.error)) {
        this._unauthenticate(true);
      }
    });
    return this.session! as InstanceType<U>;
  }

  public connectMainUseCase(mainUseCase: MainUseCase) {
    this.session = mainUseCase;
    this.session.addListener(ABORT, () => this._unauthenticate(false));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- @curio não tipa a mensagem
    this.session.addListener(UseCaseMessageType.RESPONSE, (message: any) => {
      if (isAuthError(message.error)) {
        this._unauthenticate(true);
      }
    });
    return super.connectMainUseCase(mainUseCase);
  }

  public anonymousSession() {
    return new Session(0, this._service, this._driver);
  }

  private _unauthenticate(expired: boolean) {
    this.session = undefined;
    if (expired) {
      localStorage.removeItem(STORAGEKEY);
    }
  }
}
